// prettier-ignore

define([
    'jquery',
    'underscore'
], function ($, _) {
    'use strict';

    return function () {
        $.widget('mage.configurable', $.mage.configurable, {
            _init: function () {
                this._super();
                $(document)
                    .on('ssm:newRecommendation', this._onRecommend.bind(this))
                    .on('ssm:inCart', this._onAddToCart.bind(this));
            },

            _getGender (recommendation) {
                if (recommendation.size.hasOwnProperty('target_gender')) {
                    return recommendation.size['target_gender'] === 'female'? 'women' : 'men';
                }
                return null;
            },

            _getScale (recommendation) {
                let scale = recommendation.scale;
                // Handle the data structure shenanigans...
                if (typeof scale === 'object' && 'scale' in scale) {
                    scale = scale['scale'];
                }
                // Ensure the scale has a gender, otherwise fallback...
                if (scale !== 'us_m' || scale !== 'us_w') {
                    const gender = this._getGender(recommendation);
                    scale = gender? 'us_' + gender.substring(0, 1) : 'us_m';
                }
                return scale;
            },

            _configureSettingMatchingPattern: function (attributeId, pattern) {
                const select = _.find(this.options.settings, setting => setting.attributeId === attributeId);
                if (select) {
                    const matchingOption = _.find(select.options, option => option.label.match(pattern));
                    if (matchingOption) {
                        select.value = matchingOption.value;
                        this._configureElement(select);
                    }
                }
                return this;
            },

            _configureWidth: function (gender, width) {
                // TODO replace with an improved way to retrieve attributeId by attributeCode?
                const wth = '593';
                const pattern = new RegExp(`^${gender}[^-]+- ${width}$`, 'i');
                return this._configureSettingMatchingPattern(wth, pattern);
            },

            _configureSize: function (size) {
                const sizes = '592';
                const pattern = new RegExp(`^(US )?${size}\s*$`);
                return this._configureSettingMatchingPattern(sizes, pattern);
            },

            _configureFromRecommendation: function (recommendation) {
                // todo: do we need this log?
                // eslint-disable-next-line no-console
                console.log('Received recommendation:', recommendation);

                const scale = this._getScale(recommendation);
                const gender = this._getGender(recommendation);
                const size = recommendation.size[scale].replace('.0', '');

                // Check for optional width
                if ('width' in recommendation.size && recommendation.size['width'].length) {
                    const width = recommendation.size['width'].replace('shoe_width_', '').replace('normal', 'medium');
                    this._configureWidth(gender, width);
                }
                return this._configureSize(size);
            },

            _onRecommend: function (e, recommendation) {
                this._configureFromRecommendation(recommendation);
            },

            _onAddToCart: function (e, recommendation) {
                this._configureFromRecommendation(recommendation).element.submit();
            }
        });
    };
});
